<template>
  <div class="cuti">
    <BackSection :menu="name" />
    <div class="container-fluid">
      <FormCuti />
    </div>
  </div>
</template>

<script>
import FormCuti from "@/components/FormCuti.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      name: "Form Cuti",
    };
  },
  components: {
    FormCuti,
    BackSection,
  },
};
</script>
